// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overlay-loader[data-v-d9490740]{background:hsla(0,0%,100%,.9);backdrop-filter:blur(20px);width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
